<template>
    <div class="list" v-if="dataList.length > 0">
        <ul
            v-infinite-scroll="getNewList"
            :infinite-scroll-disabled="disabled"
        >
            <li v-for="(item,index) in dataList"
                :key="index">
                <OnlyTitle v-if="item.displayType == 1"
                           :url="item.shareUrl"
                           :title="item.title"
                           :source="item.source"
                           :createTime="item.createTime * 1000"
                           >
                </OnlyTitle>
                <TopTitleBottomImage v-else-if="item.displayType == 2"
                                     :url="item.shareUrl"
                                     :title="item.title"
                                     :image="item.images[0] || ''"
                                     :source="item.source"
                                     :createTime="item.createTime * 1000"
                                     >
                </TopTitleBottomImage>
                <OneTitleThreeImage v-else-if="item.displayType == 3"
                                    :url="item.shareUrl"
                                    :title="item.title"
                                    :images="item.images"
                                    :source="item.source"
                                    :createTime="item.createTime * 1000"
                                    >
                </OneTitleThreeImage>
                <LeftTitleRightImage v-else-if="item.displayType == 4"
                                     :url="item.shareUrl"
                                     :title="item.title"
                                     :image="item.images[0] || ''"
                                     :source="item.source"
                                     :createTime="item.createTime * 1000"
                                     >
                </LeftTitleRightImage>
                <TopTitleThreeImage v-else-if="item.displayType == 5"
                                    :url="item.shareUrl"
                                    :title="item.title"
                                    :images="item.images"
                                    :source="item.source"
                                    :createTime="item.createTime * 1000"
                                    >
                </TopTitleThreeImage>
                <OnlyTitle v-else
                           :url="item.shareUrl"
                           :title="item.title"
                           :source="item.source"
                           :createTime="item.createTime * 1000"
                           >
                </OnlyTitle>
            </li>
        </ul>
        <div class="load-box" v-if="dataList.length > 0 || loading">{{topic}}</div>
        <div class="load-box" v-if="noMore">{{topic}}</div>
    </div>
</template>

<script>
import $ from "jquery";
import List from "../list/index";

export default{
    name: 'list',
    data(){
        return{
            id: 18,
            dataList: [],
            page: 1,
            cateId: null,
            topic: '上拉加载更多',
            bLen: 0,
            nLen: 0,
            loading: false
        }
    },
    computed: {
      noMore(){
        return this.nLen >= this.bLen
      },
      disabled(){
        return this.loading || this.noMore
      }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            this.axios.get("/webtopic/getWebTopic/" + this.id).then(res => {
                let data = res.data.data;
                this.cateId = res.data.data.cateId;
                this.bLen = data.bottomlist.length;

                this.axios.get("/webtopic/list", {
                    params:{
                        cateId: this.cateId,
                        page: 1,
                        limit: 10
                    }
                }).then((res) => {
                    this.dataList = res.data.data;
                    this.nLen = this.dataList.length + 10;
                })
            })
        },
        getNewList(){
            this.page++;
            this.topic = '正在加载...';
            this.loading = true;
            setTimeout(() => {
                this.axios.get("/webtopic/list", {
                    params:{
                        cateId: this.cateId,
                        page: this.page,
                        limit: 10
                    }
                }).then((res) => {
                    this.loading = false;
                    this.topic = '上拉加载更多';
                    this.dataList = this.dataList.concat(res.data.data);
                })
            }, 300)
        },
    },
    components: {
        OnlyTitle: List.OnlyTitle,
        TopTitleBottomImage: List.TopTitleBottomImage,
        OneTitleThreeImage: List.OneTitleThreeImage,
        LeftTitleRightImage: List.LeftTitleRightImage,
        TopTitleThreeImage: List.TopTitleThreeImage,
    }
}
</script>

<style lang="less" scoped>
    .list{
        padding-bottom: 1.5rem;
        height: 11rem;
        overflow-y: auto;
    }
    // ul li:first-child {
    //     padding-top: 0.2rem;
    // }
    ul li {
        margin: 0 0.3rem;
        padding: 0.4rem 0;
        border-bottom: 1px solid rgba(221, 221, 221, 0.6);
    }
    .load-box{
        text-align: center;
        padding: 0.35rem 0;
        font-size: 0.36rem;
        color: #333;
    }       
</style>   